function login(data) {
  var bypassSso = "";

  if (getUrlVars().includes("bypassSso")) {
    bypassSso = "?bypassSso";
  }

  $.ajax({
    type: "POST",
    url: "/login" + bypassSso,
    data: data,
    success: function (response) {
      handleResponse(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      alert(translate("dialog_error_occurred"));
    },
    async: true,
  });
}

function getUrlVars() {
  var vars = [],
    hash;
  var hashes = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

function changePassword(data) {
  const parts = getUserIdAndCodeFromUrl();
  const userId = parts[0];
  const code = parts[1];

  $.ajax({
    type: "POST",
    url: "/forgotpassword/changepassword/" + userId + "/" + code,
    data: data,
    success: function (response) {
      handleResponse(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      alert(translate("dialog_error_occurred"));
    },
    async: true,
  });
}

function submitForgotPasswordForm(data) {
  $.ajax({
    type: "POST",
    url: "/forgotpassword/request",
    data: data,
    success: function (response) {
      handleResponse(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      alert(translate("dialog_error_occurred"));
    },
    async: true,
  });
}

function hasRedirect(url) {
  return url.match(/\?/) && url.match(/redirect/);
}

function token() {
  const currentUrl = window.location.href;
  var url = "/token";
  if (hasRedirect(currentUrl)) {
    url += currentUrl.substring(currentUrl.indexOf("?"));
  }

  $("body").addClass("loading");

  $.ajax({
    type: "GET",
    url: url,
    success: function (response) {
      $("body").removeClass("loading");

      handleResponse(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      $("body").removeClass("loading");

      alert(translate("dialog_error_occurred"));
    },
    async: true,
  });
}

function handleResponse(response) {
  if (response.token !== undefined && response.customerUserId !== undefined) {
    window.sessionStorage.setItem("token", response.token);
    window.sessionStorage.setItem("customerUserId", response.customerUserId);
  }

  if (response.redirect !== undefined) {
    window.location.replace(response.redirect);
  }
}

function isLoginSuccess() {
  const currentUrl = window.location.pathname;

  return currentUrl === "/login-success";
}

function getUserIdAndCodeFromUrl() {
  const path = window.location.pathname;
  const pathWithUserIdAndCode = path.substring(
    path.indexOf("changepassword") + 15
  );

  return pathWithUserIdAndCode.split("/");
}

function handleFlashMessage() {
  if (
    $("ul.dynamic-flash-messages li").length > 0 &&
    $.trim($("ul.dynamic-flash-messages li:first").text()) != ""
  ) {
    $("ul.dynamic-flash-messages").slideDown(500);
  } else {
    $("ul.dynamic-flash-messages").hide();
  }
}

$().ready(function () {
  if (isLoginSuccess()) {
    token();
  }

  if (!isLoginSuccess()) {
    var userName = $("#form_gebruikersnaam").val();
    if ($.trim(userName) === "") {
      $("#form_gebruikersnaam").focus();
    } else {
      $("#registerPassword").focus();
    }

    $("form#loginform").keypress(function (e) {
      // if the key pressed is the enter key
      if (e && e.keyCode === 13) {
        $("a#loginFormSubmit").click();
      }
    });

    $("form#loginform").validation();

    $(document).ready(function () {
      window.sessionStorage.clear();
    });

    $(document).on("click", "a#loginFormSubmit", function (event) {
      event.preventDefault
        ? event.preventDefault()
        : (event.returnValue = false);

      $("a#loginFormSubmit").removeClass("done").addClass("processing");

      $("form#loginform").validation();
      if (!$("form#loginform").validation("isValid")) {
        $("a#loginFormSubmit").removeClass("processing").addClass("done");
      }
      if ($("form#loginform").validation("isValid")) {
        login($("form#loginform").serializeArray());
      }
    });

    function forgotPasswordFormSubmission() {
      $("form#forgotpasswordrequestForm").validation();
      if ($("form#forgotpasswordrequestForm").validation("isValid")) {
        submitForgotPasswordForm(
          $("form#forgotpasswordrequestForm").serializeArray()
        );
      }
    }

    $(document).on(
      "click",
      "a#forgotpasswordrequestFormSubmit",
      function (event) {
        event.preventDefault
          ? event.preventDefault()
          : (event.returnValue = false);
        forgotPasswordFormSubmission();
      }
    );

    $("#forgotpasswordrequestForm ").find('#form_gebruikersnaam').keypress(function (event) {
      if (event.which == 13) {
        event.preventDefault();
        forgotPasswordFormSubmission();
      }
    });

    $(document).on("click", "a#changepasswordFormSubmit", function (event) {
      event.preventDefault
        ? event.preventDefault()
        : (event.returnValue = false);
      $("form#changepasswordForm").validation();
      if ($("form#changepasswordForm").validation("isValid")) {
        changePassword($("form#changepasswordForm").serializeArray());
      }
    });
  }

  $(".tooltipSmall").each(function () {
    var gravity = "s";
    if ($(this).is("[gravity]")) {
      gravity = $(this).attr("gravity");
    }

    $(this).tipsy({
      gravity: gravity,
      html: true,
    });
  });

  $(".tooltipSmall").each(function () {
    var gravity = "s";
    var delay = 400;

    if ($(this).is("[gravity]")) {
      gravity = $(this).attr("gravity");
    }
    if ($(this).is("[delay]")) {
      delay = $(this).attr("delay");
    }

    $(this).tipsy({
      gravity: gravity,
      html: true,
      delayIn: delay,
    });
  });

  // Check the password with every keystroke
  if ($("#registerPassword").length > 0) {
    $("#registerPassword").on("keyup", function () {
      analysePassword($("#registerPassword").val());
    });
  }

  handleFlashMessage();
});
